module.exports = __webpack_public_path__ + "img/gzt1.4440df45.png";